module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cb5uO"))).then(() => parcelRequire('1iHdE'));